import { createContext, useContext } from 'react';
import type { AccountIdentity } from '../../helpers/authApi';

export const DashboardIdentity = createContext<AccountIdentity | null>(null);
export const useDashboardIdentity = () => useContext(DashboardIdentity);
